import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import Loader from "../../common/Loader";
import { useSidebar } from "../../common/SidebarContext";

const InitialAuth = ({ children }) => {
  const [authorized, setAuthorized] = useState(null);
  const [searchParams] = useSearchParams();
  const REDIRECT_URL = "https://app.avatare.com";
  const { profile, setProfile, setIsSupperAdmin } = useSidebar();

  const fetchProfile = async () => {
    let token = searchParams.get("token") || localStorage.getItem("token");
    let userId = searchParams.get("userId") || localStorage.getItem("UserId");


    try {

      const res = await axios.get(
        `${process.env.REACT_APP_API_ROOT}/api/auth/getprofile/?Id=${userId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = res?.data?.message;
      setProfile(res?.data?.message);
      localStorage.setItem("OrganizationId",res?.data?.message?.OrganizationId)
      const email = data?.email.trim();
      setIsSupperAdmin(
        email === "daren.jackson@avatare.com" ||
          email === "osama@divedeepai.com" ||
          email === "e.divedeepai@gmail.com"
      );
    } catch (error) {
      console.log(error);
      
    }
  };

  useEffect(() => {
    const checkAuth = async () => {
      let token = searchParams.get("token") || localStorage.getItem("token");

      if (!token) {
        window.location.href = REDIRECT_URL;
        return;
      }

      try {
        if (searchParams.get("token")) {
          localStorage.setItem("token", token);
        }

        const response = await axios.get(
          `${process.env.REACT_APP_API_ROOT}/api/auth/verify/`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        console.log(response.data);

        if (response.data === true) {
          setAuthorized(true);
        } else {
          window.location.href = REDIRECT_URL;
        }
      } catch (error) {
        window.location.href = REDIRECT_URL;
      }
    };

    checkAuth();
    fetchProfile()
  }, [searchParams]);

  if (authorized === null)
    return (
      <div className="h-screen w-screen flex justify-center items-center">
        <Loader />
      </div>
    );

  return <>{authorized && children}</>;
};

export default InitialAuth;
